<div class="popup-container">
  <div class="popup-content">
    <div class="linksContainer">
      <div class="">
        <a mat-button routerLink="/Home" (click)="skipToHome()" class="closeLink">{{ "Skip" | transloco }}</a>
      </div>
      <div class="d-flex justify-content-center align-items-center toggleLanguage">
        <div class="toggleLanguage">

        </div>

      </div>
    </div>
    <h1>{{ 'welcome to blue box' | transloco }}</h1>
    <div class="imgContainer">
      <img src="/assets/logo-01.png" [alt]="'welcome to blue box' | transloco" class="homeImg" />
    </div>
    <!-- <div class="w-100 text-center">
      <p>
        {{ "welcometext" | transloco }}
      </p>
    </div>
    <div class="btnContainer">
      <button class="btn containueBtn" (click)="goToSelect()">
        {{ "Next" | transloco }}
      </button>
    </div> -->
  </div>
</div>